const APPLICATION_FLOW_DRAFT_KEY = 'application_flow_draft_v1';

const readRawDraft = () => {
  try {
    const serializedDraft = sessionStorage.getItem(APPLICATION_FLOW_DRAFT_KEY);

    if (!serializedDraft) {
      return null;
    }

    return JSON.parse(serializedDraft);
  } catch (error) {
    sessionStorage.removeItem(APPLICATION_FLOW_DRAFT_KEY);
    return null;
  }
};

export const clearApplicationDraft = () => {
  sessionStorage.removeItem(APPLICATION_FLOW_DRAFT_KEY);
};

export const createApplicationFlowMeta = ({ phone = '', lendelaAppId = null, noDocLoanData = null } = {}) => {
  return {
    phone: phone || '',
    lendelaAppId: lendelaAppId ?? null,
    noDocLoanData: noDocLoanData ?? null,
    sourceType: lendelaAppId ? 'lendela' : noDocLoanData ? 'noDocLoan' : 'standard',
  };
};

export const isSameApplicationFlowMeta = (leftMeta, rightMeta) => {
  if (!leftMeta || !rightMeta) {
    return false;
  }

  return (
    (leftMeta.phone || '') === (rightMeta.phone || '') &&
    (leftMeta.lendelaAppId ?? null) === (rightMeta.lendelaAppId ?? null) &&
    (leftMeta.sourceType || 'standard') === (rightMeta.sourceType || 'standard') &&
    JSON.stringify(leftMeta.noDocLoanData ?? null) === JSON.stringify(rightMeta.noDocLoanData ?? null)
  );
};

export const getApplicationDraft = (expectedMeta) => {
  const draft = readRawDraft();

  if (!draft) {
    return null;
  }

  if (expectedMeta && !isSameApplicationFlowMeta(draft.meta, expectedMeta)) {
    clearApplicationDraft();
    return null;
  }

  return draft;
};

export const saveApplicationDraft = ({ meta, currentStep, form1, form21, form22, uiState }) => {
  const existingDraft = meta ? getApplicationDraft(meta) : readRawDraft();
  const nextDraft = {
    ...(existingDraft ?? {}),
    updatedAt: new Date().toISOString(),
  };

  if (meta) {
    nextDraft.meta = meta;
  }

  if (currentStep) {
    nextDraft.currentStep = currentStep;
  }

  if (form1 !== undefined) {
    nextDraft.form1 = form1;
  }

  if (form21 !== undefined) {
    nextDraft.form21 = form21;
  }

  if (form22 !== undefined) {
    nextDraft.form22 = form22;
  }

  if (uiState !== undefined) {
    nextDraft.uiState = uiState;
  }

  if (!nextDraft.meta?.phone) {
    return null;
  }

  sessionStorage.setItem(APPLICATION_FLOW_DRAFT_KEY, JSON.stringify(nextDraft));
  return nextDraft;
};

export const buildConsentRouteState = (meta) => {
  if (!meta?.phone) {
    return null;
  }

  return {
    phone: meta.phone,
    lendela_app_id: meta.lendelaAppId ?? undefined,
    no_doc_loan_data: meta.noDocLoanData ?? undefined,
  };
};

export const buildForm21RouteState = (draft, extraState = {}) => {
  if (!draft?.form1) {
    return null;
  }

  return {
    status: true,
    form1: draft.form1,
    ...extraState,
  };
};

export const buildForm22RouteState = (draft, extraState = {}) => {
  if (!draft?.form1 || !draft?.form21) {
    return null;
  }

  return {
    status: true,
    form1: draft.form1,
    form2: draft.form21,
    ...extraState,
  };
};

export const buildConfirmRouteState = (draft, extraState = {}) => {
  if (!draft?.form1 || !draft?.form21 || !draft?.form22) {
    return null;
  }

  return {
    status: true,
    form1: draft.form1,
    form2: draft.form21,
    form3: draft.form22,
    ...extraState,
  };
};
